import { TRENDING_FLAG } from '@common/constants';
import { ApplianceModel, ColorModel } from '@common/models';

export type ProductWithFeatures = ApplianceModel | ColorModel;

export const getOnTrendLabelFromProduct = (product: ProductWithFeatures): string | undefined => {
    const onTrendFeature =
        'features' in product ? product.features?.find((item) => item.name.match(TRENDING_FLAG)) : undefined;
    return onTrendFeature ? onTrendFeature?.description.toUpperCase() : undefined;
};
